import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useI18n } from "@/hooks/useI18n";
import type { SearchRatehawkRegionRow } from "@/integrations/supabase/rpc-types";

export function useRatehawkRegionSearch(query: string) {
  const { language } = useI18n();
  const [results, setResults] = useState<SearchRatehawkRegionRow[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Sotto i 3 caratteri pg_trgm non puo' usare l'indice (un trigramma sono 3
    // caratteri): la ricerca degenera in scansione completa, ~470ms contro i ~15ms
    // di una query da 3 lettere. Con 2 lettere i risultati sono comunque inservibili.
    if (query.trim().length < 3) {
      setResults([]);
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    supabase
      .rpc("search_ratehawk_regions", {
        p_query: query.trim(),
        p_lang: language ?? "en",
        p_limit: 8,
      })
      .then(({ data, error }) => {
        if (cancelled) return;
        if (!error) setResults((data as SearchRatehawkRegionRow[]) ?? []);
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [query, language]);

  return { results, isLoading };
}
